export const SUBMENU = {
  BASICS: "basics",
};

export const DEFAULT_SUBMENU = SUBMENU.BASICS;
